import React from 'react';
import { BannerSingle } from 'mf-react-ui/Banner';
import InfoCardList from 'mf-react-ui/InfoCardList';
import InfoCard from 'mf-react-ui/InfoCard';
import Button from 'mf-react-ui/Button';
import { object, string } from 'yup';
import { Formik } from 'formik';
import MaskedInput from 'react-text-mask';
import isEmpty from 'lodash/isEmpty';
import TextField, { Props as TextFieldProps } from '../../components/TextField/TextField';
import FormField from '../../components/FormField/FormField';
import formatMsisdn from '../../utils/formatters';
import { SubscribeGiftPromoCodeParams } from '../../api/types/SubscribeGiftPromoCodeParams';
import auth from '../../features/auth/utils/mym';
import LogoIcon from '../../img/icons/logo.svg';
import PayNumberIcon from '../../img/icons/pay-number.svg';
import BonusIcon from '../../img/icons/bonus.svg';
import * as images from './img';
import { KEY_STORAGE_PROMOCODE } from '../../const';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../utils/ga';
import * as imagesApp from '../../img';
import './PromoCodePage.scss';

type Props = {
  msisdn: string | null;
  subscribeGiftPromoCode: (params: SubscribeGiftPromoCodeParams) => void;
};

const PromoCodePage: React.FC<Props> = (props) => {
  const { msisdn, subscribeGiftPromoCode } = props;

  return (
    <>
      <BannerSingle
        title="Вам отправили подарок"
        {...(msisdn && {
          className: 'banner_main banner_main-promocode',
          images: {
            s: `${images.bannerImageS} 1x, ${images.bannerImageS2X} 2x, ${images.bannerImageS3X} 3x`,
            m: `${images.bannerImageM} 1x, ${images.bannerImageM2X} 2x, ${images.bannerImageM3X} 3x`,
            l: `${images.bannerImageL} 1x, ${images.bannerImageL2X} 2x, ${images.bannerImageL3X} 3x`,
            xl: `${images.bannerImageXL} 1x, ${images.bannerImageXL2X} 2x, ${images.bannerImageXL3X} 3x`,
          },
          bottomArea: (
            <Formik
              initialValues={{
                promoCode: sessionStorage.getItem(KEY_STORAGE_PROMOCODE) || '',
                phone: msisdn ? formatMsisdn(msisdn) : '+7',
              }}
              validationSchema={object().shape({
                promoCode: string().min(2).required(),
              })}
              onSubmit={(values) => {
                subscribeGiftPromoCode({ ...values, msisdn: values.phone.replace(/[+\s]/g, '') });
              }}
              enableReinitialize
              validateOnMount
            >
              {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
                <form className="form form-promocode" onSubmit={handleSubmit}>
                  <div className="form__field">
                    <FormField caption="Введите промокод из email">
                      <TextField
                        id="field-email"
                        type="text"
                        name="promoCode"
                        autoComplete="off"
                        maxLength={50}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.promoCode}
                      />
                    </FormField>
                  </div>
                  <div className="form__field">
                    <FormField caption="Ваш номер телефона">
                      <MaskedInput
                        mask={[
                          '+',
                          '7',
                          ' ',
                          /[1-9]/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                        ]}
                        id="field-phone"
                        type="tel"
                        name="phone"
                        autoComplete="off"
                        autoFocus
                        placeholder="+7 XXX XXX XX XX"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone}
                        placeholderChar={'\u2000'}
                        render={(ref, textFieldProps: TextFieldProps) => (
                          // @ts-ignore
                          <TextField ref={ref} {...textFieldProps} />
                        )}
                      />
                    </FormField>
                  </div>
                  <div className="form__actions">
                    <Button
                      className="form-promocode__action"
                      view="secondary"
                      size="l"
                      type="submit"
                      disabled={!isEmpty(errors)}
                      onClick={() =>
                        trackEventBound(
                          EventGTM.MakeConversions,
                          EventId.ClickActivateButtonInPromoCodeActivate,
                          EventCat.Gift,
                          EventName.Submit,
                          'Активировать'
                        )
                      }
                    >
                      Активировать
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          ),
        })}
        {...(!msisdn && {
          className: 'banner_main banner_main-activate',
          images: {
            s: `${imagesApp.bannerImageS} 1x, ${imagesApp.bannerImageS2X} 2x, ${imagesApp.bannerImageS3X} 3x`,
            m: `${imagesApp.bannerImageM} 1x, ${imagesApp.bannerImageM2X} 2x, ${imagesApp.bannerImageM3X} 3x`,
            l: `${imagesApp.bannerImageL} 1x, ${imagesApp.bannerImageL2X} 2x, ${imagesApp.bannerImageL3X} 3x`,
            xl: `${imagesApp.bannerImageXL} 1x, ${imagesApp.bannerImageXL2X} 2x, ${imagesApp.bannerImageXL3X} 3x`,
          },
          subtitle: (
            <>
              Чтобы его получить,
              <br /> авторизуйтесь
            </>
          ),
          button: {
            className: 'form-promocode__action',
            view: 'secondary',
            size: 'l',
            text: 'Войти в сервис',
            onClick: () => {
              trackEventBound(
                EventGTM.MakeConversions,
                EventId.ClickEnterServiceButtonInPromoCodeActivate,
                EventCat.Gift,
                EventName.Submit1,
                'Войти в сервис'
              );
              auth.authOTP();
            },
          },
        })}
      />
      <section className="section">
        <InfoCardList>
          <InfoCard
            className="info-card_promocode"
            icon={LogoIcon}
            description="Подарок может активировать только абонент МегаФона"
          />
          <InfoCard
            className="info-card_promocode"
            icon={PayNumberIcon}
            description="Если у вас уже оплачена подписка на услугу, дождитесь окончания оплаченного периода и отключите её"
          />
          <InfoCard
            className="info-card_promocode"
            icon={BonusIcon}
            description="Промокод можно активировать по 31.12.2021 включительно"
          />
        </InfoCardList>
      </section>
    </>
  );
};

export default PromoCodePage;
